import React, { useState, useEffect } from 'react';
import { formatRelativeCompact, formatDateTime } from '../utils/time';

interface RelativeTimeProps {
  dateString: string;
  className?: string;
  /** When true, shows full localized timestamp in a tooltip */
  showTooltip?: boolean;
}

const RelativeTime: React.FC<RelativeTimeProps> = ({ dateString, className = '', showTooltip = true }) => {
  const [timeString, setTimeString] = useState<string>('');

  useEffect(() => {
    setTimeString(formatRelativeCompact(dateString));
    const interval = setInterval(() => {
      setTimeString(formatRelativeCompact(dateString));
    }, 5000);
    return () => clearInterval(interval);
  }, [dateString]);

  return (
    <span
      className={className}
      title={showTooltip ? formatDateTime(dateString) : undefined}
    >
      {timeString}
    </span>
  );
};

export default RelativeTime; 